/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ServiceLevelHistoryItemType } from './';
import {
    ServiceLevelHistoryItemTypeFromJSON,
    ServiceLevelHistoryItemTypeFromJSONTyped,
    ServiceLevelHistoryItemTypeToJSON,
} from './';
import type { ServiceLevelType } from './';
import {
    ServiceLevelTypeFromJSON,
    ServiceLevelTypeFromJSONTyped,
    ServiceLevelTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ServiceLevelHistoryItemResource
 */
export interface ServiceLevelHistoryItemResource {
    /**
     * 
     * @type {ServiceLevelType}
     * @memberof ServiceLevelHistoryItemResource
     */
    serviceLevel: ServiceLevelType;
    /**
     * 
     * @type {Date}
     * @memberof ServiceLevelHistoryItemResource
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelHistoryItemResource
     */
    authorFullName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceLevelHistoryItemResource
     */
    authorIsSystem: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelHistoryItemResource
     */
    reason?: string;
    /**
     * 
     * @type {ServiceLevelHistoryItemType}
     * @memberof ServiceLevelHistoryItemResource
     */
    type: ServiceLevelHistoryItemType;
}

/**
 * Check if a given object implements the ServiceLevelHistoryItemResource interface.
 */
export function instanceOfServiceLevelHistoryItemResource(value: object): value is ServiceLevelHistoryItemResource {
    if (!('serviceLevel' in value) || value['serviceLevel'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('authorIsSystem' in value) || value['authorIsSystem'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ServiceLevelHistoryItemResourceFromJSON(json: any): ServiceLevelHistoryItemResource {
    return ServiceLevelHistoryItemResourceFromJSONTyped(json, false);
}

export function ServiceLevelHistoryItemResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLevelHistoryItemResource {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceLevel': ServiceLevelTypeFromJSON(json['serviceLevel']),
        'date': (new Date(json['date'])),
        'authorFullName': json['authorFullName'] == null ? undefined : json['authorFullName'],
        'authorIsSystem': json['authorIsSystem'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'type': ServiceLevelHistoryItemTypeFromJSON(json['type']),
    };
}

export function ServiceLevelHistoryItemResourceToJSON(value?: ServiceLevelHistoryItemResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'serviceLevel': ServiceLevelTypeToJSON(value['serviceLevel']),
        'date': ((value['date']).toISOString()),
        'authorFullName': value['authorFullName'],
        'authorIsSystem': value['authorIsSystem'],
        'reason': value['reason'],
        'type': ServiceLevelHistoryItemTypeToJSON(value['type']),
    };
}

